import { memo } from 'react';

/** Memoized public page body — avoids re-rendering Puck content when nav chrome updates. */
const PublicMain = memo(function PublicMain({ children }) {
  return <main className="min-h-screen">{children}</main>;
});

export default PublicMain;
